// extracted by mini-css-extract-plugin
module.exports = {"noDecoration":"OrphanNavBar_noDecoration__Ce0DP"};